var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('web-text',{attrs:{"level":4,"color":"gray","weight":"md","size":"xs","customClass":"mb-4"}}),_c('basic-triangle',{attrs:{"level":4,"color":"blue","size":"xl","customClass":"mx-auto"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }